import classNames from 'classnames';
import T from 'prop-types';
import React, { useState } from 'react';
import Maps from '../../Maps';

import { CloseModalButton, ModalPanel, OpenModalButton } from '../../Modal';
import FullscreenModal from '../../Modal/fullscreen-modal';
import Infowindow from '../findcare-map/info-window';
import MapControls from '../findcare-map/map-controls';

const SearchListItem = (props) => {
  let showServices =
    props.HasLovContract ||
    props.HasMvkServices ||
    props.VaccinatesForFlu ||
    props.VaccinatesForCovid19 ||
    props.VideoOrChat ||
    props.HasListing ||
    props.HasListingQueue;

  const [linkHasFocus, setLinkHasFocus] = useState(false);

  const focusHandler = {
    onFocus: () => setLinkHasFocus(true),
    onBlur: () => setLinkHasFocus(false),
  };

  const wrapperClasses = classNames({
    'findcare-search-list-item': true,
    'findcare-search-list-item--focus': linkHasFocus,
  });

  return (
    <div className={wrapperClasses}>
      <div className="c-related__item">
        <div className="c-related__item__container c-related__item__container--no-z-index">
          <div className="row">
            <div className="medium-8 columns">
              <div className="findcare-search-list-item__info">
                <a {...focusHandler} href={props.Url}>
                  <h3 className="findcare-search-list-item__heading">
                    {props.Heading}
                  </h3>
                  <p className="findcare-search-list-item__address">
                    {props.Address}
                  </p>
                </a>
              </div>
              <ul className="findcare-search-list-item__contact-list">
                {props.PhoneNumber && (
                  <li>
                    <a
                      className="findcare-search-list-item__contact-list__phone"
                      href={`tel:${props.InternationalPhoneNumber}`}
                    >
                      <span>{props.PhoneNumber}</span>
                    </a>
                  </li>
                )}
                {props.Latitude && props.Longitude && (
                  <li>
                    <OpenModalButton
                      className="findcare-fullscreen__modal-open"
                      id={`${props.HsaId}__findcare-fullscreen`}
                      fullScreen={true}
                    >
                      <span>Visa på karta</span>
                    </OpenModalButton>

                    <FullscreenModal
                      id={`${props.HsaId}__findcare-fullscreen`}
                      classModifier="findcare-fullscreen"
                    >
                      <Maps
                        className="findcare-map__gmap"
                        modifiers={{ 'findcare-map__gmap--modal': true }}
                        mapApiKey={props.apiKey}
                        zoom={15}
                        options={{
                          disableDefaultUI: true,
                        }}
                        markerOptions={props.markerOptions}
                        markerData={props}
                        onMarkerClick={(markerData, marker, map) => {
                          Infowindow(markerData, marker, map);
                        }}
                        lat={props.Latitude}
                        lng={props.Longitude}
                      >
                        {(map, googleAPI) => (
                          <MapControls
                            map={map}
                            googleAPI={googleAPI}
                            zoom={true}
                            plannerLink={true}
                            plannerLinkText={
                              props.Translations.biggermaptravelplanner
                            }
                            lat={props.Latitude}
                            lng={props.Longitude}
                          />
                        )}
                      </Maps>
                    </FullscreenModal>
                  </li>
                )}
                {props.HasMvkServices && props.hasAltLayout && (
                  <li className="findcare-search-list-item__eservices">
                    <p>{props.Translations.haseservices}</p>
                  </li>
                )}
              </ul>
            </div>
            <div className="medium-4 columns">
              {showServices && (
                <ul className="findcare-search-list-item__list">
                  {props.HasLovContract && (
                    <li className="findcare-search-list-item__list__item">
                      {props.LovContractLinkText}
                      <OpenModalButton
                        open={`${props.HsaId}__lov-contract`}
                        id={`${props.HsaId}__lov-contract`}
                        className={'findcare-tooltip__modal-open'}
                      >
                        <span />
                      </OpenModalButton>
                      <div className="findcare-tooltip__modal-container">
                        <ModalPanel whenActive={`${props.HsaId}__lov-contract`}>
                          <div
                            className={classNames({
                              'findcare-tooltip__modal-panel': true,
                            })}
                          >
                            <CloseModalButton
                              id={`${props.HsaId}__lov-contract`}
                              className={'findcare-tooltip__modal-close'}
                            >
                              <span className="show-for-sr">Stäng</span>
                            </CloseModalButton>

                            <div className="findcare-tooltip__modal-panel__content">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: props.LovContractDescription,
                                }}
                              />
                            </div>
                          </div>
                        </ModalPanel>
                      </div>
                    </li>
                  )}
                  {props.HasMvkServices && !props.hasAltLayout && (
                    <li className="findcare-search-list-item__list__item">
                      <p>{props.Translations.haseservices}</p>
                    </li>
                  )}
                  {props.HasListing && (
                    <li className="findcare-search-list-item__list__item">
                      <p>
                        {props.HasListingQueue
                          ? props.Translations.haslistingqueue
                          : props.Translations.haslisting}
                      </p>
                    </li>
                  )}
                  {props.VaccinatesForCovid19 && (
                    <li className="findcare-search-list-item__list__item">
                      <p> {props.Translations.vaccinatescovid19}</p>
                    </li>
                  )}
                  {props.VaccinatesForFlu && (
                    <li className="findcare-search-list-item__list__item">
                      <p>{props.Translations.vaccinatesflu}</p>
                    </li>
                  )}
                  {props.VideoOrChat && (
                    <li className="findcare-search-list-item__list__item">
                      <p>{props.Translations.videoorchat}</p>
                    </li>
                  )}
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SearchListItem.propTypes = {
  Address: T.string,
  Heading: T.string,
  Url: T.string,
  HasLovContract: T.bool,
  HasMvkServices: T.bool,
  HsaId: T.string,
  Latitude: T.number,
  Longitude: T.number,
  LovContractDescription: T.string,
  LovContractLinkText: T.string,
  PhoneNumber: T.string,
  Translations: T.shape({
    vaccinatesflu: T.string,
    vaccinatescovid19: T.string,
    haseservices: T.string,
    haslisting: T.string,
    haslistingqueue: T.string,
  }),
  VaccinatesForFlu: T.bool,
  VaccinatesForCovid19: T.bool,
  HasListing: T.bool,
  HasListingQueue: T.bool,
  apiKey: T.string,
  markerImage: T.string,
};

export default SearchListItem;
